export type StatutCommande = 'EN_ATTENTE' | 'EN_COUPE' | 'EN_COUTURE' | 'TERMINE' | 'LIVRE' | 'ANNULEE';

export type RoleUtilisateur = 'superadmin' | 'vendeur' | 'responsable_atelier' | 'gerant';

export interface Client {
  id: string;
  nom: string;
  telephone: string;
}

export interface Mesures {
  poitrine: string;
  taille: string;
  hanches: string;
  longueur: string;
  notes: string;
}

export interface Paiement {
  total: number;
  acompte: number;
  reste: number;
  modePaiement: string;
  remise?: number;
  vendeur?: string;
}

export interface ValidationEtape {
  etape: StatutCommande;
  validePar: string;
  date: string;
  heure: string;
  commentaire?: string;
}

export interface CommandeTissu {
  id?: string;
  tissu_stock_id?: string;
  is_client_cloth: boolean;
  description: string;
  quantite: number;
  tissu_nom?: string;
  tissu_image?: string;
}

export interface CommandeArticle {
  id?: string;
  type_habit_id: string;
  type_nom?: string;
  type_icon?: string;
  modele_id?: string;
  modele_nom?: string;
  modele_image?: string;
  quantite: number;
  prix_unitaire: number;
  total_ligne: number;
  tissus: CommandeTissu[];
}

export interface Commande {
  id: string;
  code?: string;
  client: Client;
  statut: StatutCommande;
  mesures: Mesures;
  articles?: CommandeArticle[];
  paiement: Paiement;
  dateCommande: string;
  dateLivraison: string;
  coupeur?: string;
  tailleur?: string;
  validations: ValidationEtape[];
  notes?: string;
  modele?: string;
  modelImage?: string;
  tissuClient?: boolean;
  tissuDescription?: string;
  tissuStockId?: string;
  tissuImage?: string;
  tissuNom?: string;
  quantiteTissu?: number;
  client_nom?: string;
  client_tel?: string;
  coupeur_id?: number;
  tailleur_id?: number;
  cout_main_doeuvre_coupe?: number;
  cout_main_doeuvre_couture?: number;
}

export const statutLabels: Record<StatutCommande, string> = {
  EN_ATTENTE: 'En attente',
  EN_COUPE: 'En coupe',
  EN_COUTURE: 'En couture',
  TERMINE: 'Terminé',
  LIVRE: 'Livré',
  ANNULEE: 'Annulée',
};

export const statutColors: Record<StatutCommande, string> = {
  EN_ATTENTE: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  EN_COUPE: 'bg-blue-100 text-blue-800 border-blue-300',
  EN_COUTURE: 'bg-purple-100 text-purple-800 border-purple-300',
  TERMINE: 'bg-green-100 text-green-800 border-green-300',
  LIVRE: 'bg-gray-100 text-gray-700 border-gray-300',
  ANNULEE: 'bg-red-100 text-red-700 border-red-300',
};

export const commandesMock: Commande[] = [
  {
    id: 'CMD-001',
    client: { id: 'c1', nom: 'Aminata Coulibaly', telephone: '+223 76 12 34 56' },
    statut: 'EN_COUTURE',
    modele: 'Boubou Grande Dame',
    modelImage: 'https://readdy.ai/api/search-image?query=elegant%20African%20women%20boubou%20dress%20grand%20boubou%20full%20length%20traditional%20mali%20bamako%20richly%20embroidered%20gold%20neckline%20warm%20cream%20background%20fashion%20photography&width=400&height=400&seq=model001&orientation=squarish',
    mesures: { poitrine: '92', taille: '76', hanches: '98', longueur: '130', notes: 'Encolure arrondie, finitions soignées' },
    tissuClient: false,
    tissuDescription: 'Basin riche doré',
    tissuStockId: 'p1',
    quantiteTissu: 5,
    paiement: { total: 45000, acompte: 20000, reste: 25000, modePaiement: 'Espèces' },
    dateCommande: '2026-03-20',
    dateLivraison: '2026-03-28',
    coupeur: 'Ibrahim Traoré',
    tailleur: 'Moussa Diallo',
    notes: 'Cliente VIP, livraison prioritaire',
    validations: [
      { etape: 'EN_ATTENTE', validePar: 'Salimata Diarra', date: '2026-03-20', heure: '09:15', commentaire: 'Commande enregistrée' },
      { etape: 'EN_COUPE', validePar: 'Ibrahim Traoré', date: '2026-03-21', heure: '10:30', commentaire: 'Tissu vérifié, coupe débutée' },
      { etape: 'EN_COUTURE', validePar: 'Souleymane Keita', date: '2026-03-22', heure: '14:00', commentaire: 'Coupe validée, transmis à Moussa' },
    ],
  },
  {
    id: 'CMD-002',
    client: { id: 'c2', nom: 'Fatoumata Keita', telephone: '+223 65 98 76 54' },
    statut: 'EN_COUPE',
    modele: 'Robe Wax Moderne',
    modelImage: 'https://readdy.ai/api/search-image?query=modern%20African%20wax%20print%20dress%20ankara%20colorful%20geometric%20patterns%20woman%20fashion%20Bamako%20Mali%20elegant%20styled%20photography%20clean%20background&width=400&height=400&seq=model002&orientation=squarish',
    mesures: { poitrine: '88', taille: '70', hanches: '94', longueur: '110', notes: 'Manches 3/4, col bateau' },
    tissuClient: true,
    tissuDescription: 'Wax hollandais apporté par la cliente',
    quantiteTissu: 3.5,
    paiement: { total: 25000, acompte: 15000, reste: 10000, modePaiement: 'Orange Money' },
    dateCommande: '2026-03-21',
    dateLivraison: '2026-03-27',
    coupeur: 'Ibrahim Traoré',
    validations: [
      { etape: 'EN_ATTENTE', validePar: 'Kadidiatou Traoré', date: '2026-03-21', heure: '11:00' },
      { etape: 'EN_COUPE', validePar: 'Souleymane Keita', date: '2026-03-22', heure: '09:00', commentaire: 'Tissu client reçu et vérifié' },
    ],
  },
  {
    id: 'CMD-003',
    client: { id: 'c3', nom: 'Mariam Sanogo', telephone: '+223 74 55 66 77' },
    statut: 'EN_ATTENTE',
    modele: 'Ensemble 2 pièces',
    modelImage: 'https://readdy.ai/api/search-image?query=African%20two%20piece%20outfit%20ensemble%20haut%20jupe%20wax%20batik%20pattern%20Mali%20traditional%20modern%20woman%20elegant%20cream%20background%20studio%20fashion&width=400&height=400&seq=model003&orientation=squarish',
    mesures: { poitrine: '96', taille: '82', hanches: '104', longueur: '95', notes: '' },
    tissuClient: false,
    tissuDescription: 'Bogolan naturel',
    tissuStockId: 'p3',
    quantiteTissu: 3,
    paiement: { total: 35000, acompte: 10000, reste: 25000, modePaiement: 'Wave' },
    dateCommande: '2026-03-23',
    dateLivraison: '2026-04-01',
    validations: [
      { etape: 'EN_ATTENTE', validePar: 'Salimata Diarra', date: '2026-03-23', heure: '15:30' },
    ],
  },
  {
    id: 'CMD-004',
    client: { id: 'c4', nom: 'Bintou Dembélé', telephone: '+223 78 22 44 88' },
    statut: 'TERMINE',
    modele: 'Kaftan Brodé',
    modelImage: 'https://readdy.ai/api/search-image?query=African%20kaftan%20dress%20richly%20embroidered%20neckline%20sleeves%20traditional%20West%20Africa%20Mali%20elegant%20formal%20wear%20warm%20background%20golden%20tones&width=400&height=400&seq=model004&orientation=squarish',
    mesures: { poitrine: '90', taille: '74', hanches: '96', longueur: '140', notes: 'Broderies sur les manches, passementerie en or' },
    tissuClient: false,
    tissuDescription: 'Soie importée crème',
    tissuStockId: 'p4',
    quantiteTissu: 6,
    paiement: { total: 80000, acompte: 40000, reste: 40000, modePaiement: 'Espèces' },
    dateCommande: '2026-03-15',
    dateLivraison: '2026-03-25',
    coupeur: 'Seydou Coulibaly',
    tailleur: 'Boubacar Diarra',
    validations: [
      { etape: 'EN_ATTENTE', validePar: 'Salimata Diarra', date: '2026-03-15', heure: '10:00' },
      { etape: 'EN_COUPE', validePar: 'Seydou Coulibaly', date: '2026-03-17', heure: '08:30' },
      { etape: 'EN_COUTURE', validePar: 'Souleymane Keita', date: '2026-03-18', heure: '11:00', commentaire: 'Coupe impeccable' },
      { etape: 'TERMINE', validePar: 'Boubacar Diarra', date: '2026-03-23', heure: '16:45', commentaire: 'Couture terminée, prêt pour livraison' },
    ],
  },
  {
    id: 'CMD-005',
    client: { id: 'c5', nom: 'Oumou Traoré', telephone: '+223 69 33 55 11' },
    statut: 'EN_ATTENTE',
    modele: 'Tenue de Cérémonie',
    modelImage: 'https://readdy.ai/api/search-image?query=ceremonial%20African%20gown%20grand%20boubou%20wedding%20ceremony%20formal%20elegant%20woman%20Bamako%20Mali%20golden%20embroidery%20basin%20riche%20beige%20background&width=400&height=400&seq=model005&orientation=squarish',
    mesures: { poitrine: '86', taille: '68', hanches: '92', longueur: '145', notes: 'Pour mariage le 5 avril, urgence' },
    tissuClient: true,
    tissuDescription: 'Basin léger blanc apporté par la cliente',
    quantiteTissu: 7,
    paiement: { total: 60000, acompte: 30000, reste: 30000, modePaiement: 'Orange Money' },
    dateCommande: '2026-03-24',
    dateLivraison: '2026-04-03',
    notes: 'Mariage le 5 avril — délai impératif',
    validations: [
      { etape: 'EN_ATTENTE', validePar: 'Kadidiatou Traoré', date: '2026-03-24', heure: '09:00' },
    ],
  },
  {
    id: 'CMD-006',
    client: { id: 'c6', nom: 'Aïchata Traoré', telephone: '+223 77 88 99 00' },
    statut: 'LIVRE',
    modele: 'Robe Pagne Simple',
    modelImage: 'https://readdy.ai/api/search-image?query=simple%20pagne%20African%20dress%20casual%20everyday%20wear%20woman%20Mali%20Bamako%20colorful%20fabric%20traditional%20clean%20neutral%20background%20studio%20photography&width=400&height=400&seq=model006&orientation=squarish',
    mesures: { poitrine: '84', taille: '66', hanches: '90', longueur: '100', notes: '' },
    tissuClient: false,
    tissuDescription: 'Pagne coton multicolore',
    tissuStockId: 'p5',
    quantiteTissu: 2.5,
    paiement: { total: 18000, acompte: 18000, reste: 0, modePaiement: 'Espèces' },
    dateCommande: '2026-03-10',
    dateLivraison: '2026-03-18',
    coupeur: 'Ibrahim Traoré',
    tailleur: 'Moussa Diallo',
    validations: [
      { etape: 'EN_ATTENTE', validePar: 'Salimata Diarra', date: '2026-03-10', heure: '10:00' },
      { etape: 'EN_COUPE', validePar: 'Ibrahim Traoré', date: '2026-03-11', heure: '09:00' },
      { etape: 'EN_COUTURE', validePar: 'Souleymane Keita', date: '2026-03-12', heure: '14:00' },
      { etape: 'TERMINE', validePar: 'Moussa Diallo', date: '2026-03-17', heure: '17:00' },
      { etape: 'LIVRE', validePar: 'Salimata Diarra', date: '2026-03-18', heure: '11:30', commentaire: 'Livré, solde payé' },
    ],
  },
];

export const clientsMock: Client[] = [
  { id: 'c1', nom: 'Aminata Coulibaly', telephone: '+223 76 12 34 56' },
  { id: 'c2', nom: 'Fatoumata Keita', telephone: '+223 65 98 76 54' },
  { id: 'c3', nom: 'Mariam Sanogo', telephone: '+223 74 55 66 77' },
  { id: 'c4', nom: 'Bintou Dembélé', telephone: '+223 78 22 44 88' },
  { id: 'c5', nom: 'Oumou Traoré', telephone: '+223 69 33 55 11' },
  { id: 'c6', nom: 'Aïchata Traoré', telephone: '+223 77 88 99 00' },
  { id: 'c7', nom: 'Kadiatou Diallo', telephone: '+223 71 44 22 66' },
  { id: 'c8', nom: 'Rokiatou Camara', telephone: '+223 75 11 33 99' },
];

export const modellesMock = [
  { id: 'm1', nom: 'Boubou Grande Dame', categorie: 'Traditionnel', prix: 45000, image: 'https://readdy.ai/api/search-image?query=elegant%20grand%20boubou%20African%20traditional%20dress%20woman%20formal%20Mali%20basin%20riche%20embroidered%20gold%20beige%20studio&width=300&height=300&seq=mod001&orientation=squarish' },
  { id: 'm2', nom: 'Robe Wax Moderne', categorie: 'Moderne', prix: 25000, image: 'https://readdy.ai/api/search-image?query=modern%20wax%20print%20dress%20African%20ankara%20woman%20colorful%20geometric%20fashion%20styled%20photography%20Bamako&width=300&height=300&seq=mod002&orientation=squarish' },
  { id: 'm3', nom: 'Ensemble 2 pièces', categorie: 'Moderne', prix: 35000, image: 'https://readdy.ai/api/search-image?query=African%20two%20piece%20set%20top%20skirt%20wax%20fabric%20modern%20woman%20elegant%20clean%20background%20studio%20fashion&width=300&height=300&seq=mod003&orientation=squarish' },
  { id: 'm4', nom: 'Kaftan Brodé', categorie: 'Cérémonie', prix: 80000, image: 'https://readdy.ai/api/search-image?query=kaftan%20African%20embroidered%20formal%20ceremony%20dress%20woman%20Mali%20rich%20fabric%20golden%20thread%20elegant%20neutral%20background&width=300&height=300&seq=mod004&orientation=squarish' },
  { id: 'm5', nom: 'Tenue Cérémonie', categorie: 'Cérémonie', prix: 60000, image: 'https://readdy.ai/api/search-image?query=ceremonial%20African%20wedding%20outfit%20grand%20boubou%20formal%20gown%20woman%20elegant%20Mali%20cream%20background%20studio&width=300&height=300&seq=mod005&orientation=squarish' },
  { id: 'm6', nom: 'Robe Pagne Simple', categorie: 'Casual', prix: 18000, image: 'https://readdy.ai/api/search-image?query=simple%20casual%20African%20pagne%20dress%20colorful%20everyday%20wear%20woman%20Bamako%20neutral%20background%20fashion%20photography&width=300&height=300&seq=mod006&orientation=squarish' },
  { id: 'm7', nom: 'Complet Homme Basin', categorie: 'Homme', prix: 40000, image: 'https://readdy.ai/api/search-image?query=African%20man%20traditional%20complet%20suit%20basin%20riche%20formal%20wear%20Mali%20elegant%20embroidered%20neutral%20light%20background%20studio&width=300&height=300&seq=mod007&orientation=squarish' },
  { id: 'm8', nom: 'Boubou Homme', categorie: 'Homme', prix: 30000, image: 'https://readdy.ai/api/search-image?query=African%20man%20grand%20boubou%20flowing%20robe%20traditional%20Mali%20formal%20elegant%20fabric%20neutral%20background%20studio%20photography&width=300&height=300&seq=mod008&orientation=squarish' },
];
